<template>
	<span v-if="infoText" v-tooltip="`${infoText}`">
		<img class="info-icon" :src="getInfoIcon()" />
	</span>
</template>

<script>
export default {
	props: {
		infoText: {
			type: String,
			default: null,
		},
	},
	methods: {
		getInfoIcon() {
			// eslint-disable-next-line
			var infoIcon = APP_INFO_ICON;
			return require('@/assets/img/' + infoIcon);
		},
	},
};
</script>

<style></style>
